<template>
    <CRow>
        <DFabs>
            <div>
                <DFormTextarea
                    v-if="showChangeReasonInput"
                    v-model="changeReason"
                    class="change-reason change-reason-modal"
                    :placeholder="__('messages.change_reason')"
                    add-input-classes="bg-light"
                    :is-valid="isFormFieldValid('activity_log_comment')"
                    :invalid-feedback="errors.activity_log_comment"
                    maxlength="1000"
                    @update:modelValue="updateValue"
                />
                <div
                    v-if="showIncidentList === true && incidents.length > 1 && userPermissions.includes('customer.incidents_view') && userPermissions.includes('customer.incidents_manage')"
                    class="incident-class"
                >
                    <span>{{ __('customers.business_incidents.add_to_incident') }}</span>
                    <DSelect
                        id="add_incident"
                        v-model="incidentId"
                        :options="incidents"
                        :is-valid="isFormFieldValid('incident_id')"
                        @change="updateIncident"
                    />
                </div>
                <p
                    v-if="errors.incident_id"
                    class="error-msg"
                >
                    {{ errors.incident_id }}
                </p>
            </div>
            <slot name="additional_button_before_submit" />
            <DFab
                id="btn-save"
                :disabled="disabled"
                :icon="submitIcon"
                :label="__(submitMessage)"
                @click="submit"
            />
            <slot name="additional_button" />
            <DFab
                v-if="cancelRoute"
                icon="close"
                color="secondary"
                @click="showConfirmModal"
            />
        </DFabs>

        <DModal
            v-model:show="isModalOpen"
            :title="__('messages.delete_confirm.title')"
            :message="__('messages.delete_confirm.message')"
            is-error
            is-confirm
            @confirm="handleCancel"
            @close="isModalOpen = false"
        />
    </CRow>
</template>

<script>

export default {
    name: 'DFormControls',
    components: {
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        cancelRoute: {
            type: [String, Boolean],
            default: false
        },
        dirty: {
            type: Boolean,
            default: true
        },
        submitMessage: {
            type: String,
            required: false,
            default: 'messages.save'
        },
        submitIcon: {
            type: String,
            required: false,
            default: 'content-save'
        },
        showChangeReasonInput: {
            type: Boolean,
            default: false
        },
        showIncidentList: {
            type: Boolean,
            default: false
        },
        customerId: {
            type: Number,
            default: 0
        }
    },
    emits: ['submit', 'submitSecond', 'update:modelValue', 'setIncident'],
    data () {
        return {
            isModalOpen: false,
            changeReason: '',
            incidents: [],
            incidentId: null
        }
    },
    computed: {
        errors () {
            return this.$page.props.errors
        },
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    created () {
        if (this.showIncidentList === true && this.customerId !== 0 && this.userPermissions.includes('customer.incidents_view') && this.userPermissions.includes('customer.incidents_manage')) {
            window.axios.get(this.$route('customers.customers.get-customer-open-business-incidents-array', this.customerId))
                .then(response => {
                    this.incidents = response.data.incidents
                })
        }
    },
    methods: {
        submit () {
            if (this.isInLoadingState === true) {
                // We are loading something so do make submit availbale till finished
                return
            }

            // We assume the integrating Page does something with this event and may fire an Intertia
            // which will then toggle our loading state based on registered events.
            this.$emit('submit')
        },
        submitSecond () {
            if (this.isInLoadingState === true) {
                // We are loading something so do make submit availbale till finished
                return
            }

            // We assume the integrating Page does something with this event and may fire an Intertia
            // which will then toggle our loading state based on registered events.
            this.$emit('submitSecond')
        },
        showConfirmModal () {
            if (this.dirty) {
                this.isModalOpen = true
            } else {
                this.handleCancel()
            }
        },
        handleCancel () {
            this.$inertia.get(this.cancelRoute)
        },
        updateValue () {
            this.$emit('update:modelValue', this.changeReason)
        },
        updateIncident () {
            this.$emit('setIncident', this.incidentId)
        }
    }
}
</script>
<style>
.change-reason {
    margin: 0.5rem 0;
}
.change-reason-modal {
    width: 200px !important;
}
.incident-class {
    padding-top: 10px !important;
    padding-right: 10px !important;
    display: grid !important;
    grid-template-columns: auto auto !important;
    grid-gap: 10px !important;
    align-items: center !important;
    width: 100% !important;
}
.error-msg {
    margin: 3px 0 0 75px;
    text-align: center;
    font-size: 12px;
    color: #ef4d4d;
}
</style>
